export const getLocaleString = (languageCode: string, countryCode: string) => `${languageCode}-${countryCode}`;